export const EventTypePolicy = ({

    EVENT_PUBLIC_HOLIDAY: "PUBLIC_HOLIDAY",
    EVENT_SUNDAY: "SUNDAY",
    EVENT_TYPHOON: "TYPHOON",

})